.form {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.textarea-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.textarea-label {
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-medium);
  color: var(--color-neutral-600);
  height: 1rem;
}

.char-count {
  font-size: var(--font-size-xs);
  color: var(--color-neutral-400);
  text-align: right;
  margin-top: 4px;
}

.textarea {
  width: 100%;
  resize: vertical;
  padding: var(--spacing-size-4xs) var(--spacing-size-3xs);
  font-size: var(--font-size-md);
  line-height: var(--line-height-md);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  color: var(--color-neutral-600);
  background-color: var(--color-opacity-default);
  border: var(--border-width-xs) solid var(--color-neutral-200);
  border-radius: var(--border-radius-sm);
  outline: none;
  box-sizing: border-box;
}
.textarea::placeholder {
  color: var(--color-neutral-400);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-md);
}
.textarea:hover {
  border-color: var(--color-action-default);
  background-color: var(--color-opacity-hover);
}
.textarea:focus {
  outline: var(--border-width-default) solid var(--color-action-default);
  outline-offset: -1px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */